import { render } from "./NavCollapse.vue?vue&type=template&id=6279af10"
import script from "./NavCollapse.vue?vue&type=script&lang=js"
export * from "./NavCollapse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__